const en = {
  title: 'Message Receiver Setting',
  name: 'Receiver’s name',
  email: 'Receiver’s email',
  phone: 'Receiver’s phone',
  emailType: 'Message type',
  groups: 'Group',
  search: 'SEARCH',
  reset: 'CLEAR ALL',
  addReveiver: 'ADD NEW RECEIVER',
  action: 'Operation',
  selectReceiverType: 'Secet the receiver type',
  // isOperator: '请选择系统操作员',
  perator: 'Operator',
  noOperator: 'Non-Operator',
  basicInfo: 'Basic information',
  operatorName: 'Operator name',
  operatorEmail: 'Operator email',
  operatorPhone: 'Operator phone',
  receiverName: 'Name',
  receiverEmail: 'Email',
  receiverPhone: 'Phone',
  seeAll: 'See all',
  edit: 'Edit',
  deleteTip: 'Are you sure to delete this message receiver',
  delete: 'Delete',
  editReceiver: 'Edit Receiver',
  msgType: 'Message type',
  allMsgtype: 'All message types',
  futureMsgType: 'This option includes the types we will add in the future.',
  futureNewGroup: 'This option includes the groups we will add in the future.',

  selectAll: 'Select all',
  group: 'Group',
  allGroups: 'All groups',
  groupTip: 'Receiver will only receive the message of groups selected',
  groupNotSelected: 'Group not selected',
  groupSelected: 'Group selected',
  add: 'ADD',
  comfirm: 'Comfirm',
  cancel: 'CANCEL',
  editeReveiver: 'SAVE',
  modifySuccess: 'The modification was successful',
  modifyFail: 'The modification failed',
  addSuccess: 'Added successfully',
  addFail: 'Failed to add',
  deleteSuccess: 'Delete successfully'
}

export default en
